import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { DataService } from 'src/app/services/data.service';
import { Component, OnInit } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import { Label, MultiDataSet } from 'ng2-charts';
import { interval } from 'rxjs';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent implements OnInit {
  // Create an Observable that will publish a value on an interval.
  secondsCounter = interval(2000);

  totalPolls = 0;
  percentage1 = 0;
  percentage2 = 0;
  percentage3 = 0;
  percentage4 = 0;
  label1 = 'Han aceptado haber tenido ya relaciones sexuales';
  label2 = 'Conocen algún metodo anticonceptivo';
  label3 = 'Conocen a alguna adolescente embarazada o madre soltera';
  label4 = 'Interesados en obtener información sobre cómo cuidarse';

  commonChartsConfig = {
    type: 'doughnut' as ChartType,
    legend: true,
    plugins: [pluginDataLabels],
    options: {
      legend: { display: false },
      responsive: true,
      tooltips: {
        callbacks: {
          label: (t, d) => {
            const xLabel = d.labels[t.index];
            const yLabel = d.datasets[0].data[t.index];
            return xLabel + ': ' + yLabel;
          }
        }
      },
      plugins: {
        // Change options for ALL labels of THIS CHART
        datalabels: {
            color: '#FFF',
            textShadowBlur: 4,
            textShadowColor: '#000',
            font: {
              size: 20,
              weight: 'bold'
            }
        }
      }
    } as ChartOptions,
  };

  chart1 = {
    config: this.commonChartsConfig,
    loading: false,
    colors: [ { backgroundColor : [ '#0099DC', '#FFCE01' ] } ] as any[],
    labels: [ 'Sí', 'No' ] as Label[],
    data: [0, 0]
  };

  chart2 = {
    config: this.commonChartsConfig,
    loading: false,
    colors: [ { backgroundColor : [ '#0099DC', '#FFCE01' ] } ] as any[],
    labels: [ 'Sí', 'No' ] as Label[],
    data: [0, 0]
  };

  chart3 = {
    config: this.commonChartsConfig,
    loading: false,
    colors: [ { backgroundColor : [ '#0099DC', '#FFCE01' ] } ] as any[],
    labels: [ 'Sí', 'No' ] as Label[],
    data: [0, 0]
  };

  chart4 = {
    config: this.commonChartsConfig,
    loading: false,
    colors: [ { backgroundColor : [ '#0099DC', '#FFCE01' ] } ] as any[],
    labels: [ 'Sí', 'No' ] as Label[],
    data: [0, 0]
  };

  constructor(private dataService: DataService) {
    this.secondsCounter.subscribe(n => {
      this.dataService.getExpressAnswers().subscribe(data => {
        if (data.answers !== []) {
          this.setData(data);
        }
      });
    });
  }

  ngOnInit() {
    this.dataService.getExpressAnswers().subscribe(data => {
      if (data.answers !== []) {
        this.setData(data);
      }
    });
  }

  setData(data: any): void {
    // Set total polls.
    this.totalPolls = data.total;

    // Set charts data.
    this.chart1.data = data.answers[0].chart_data.data;
    this.chart2.data = data.answers[1].chart_data.data;
    this.chart3.data = data.answers[2].chart_data.data;
    this.chart4.data = data.answers[3].chart_data.data;

    // Set percentages.
    this.percentage1 = Math.round(this.chart1.data[0] * 100 / this.totalPolls);
    this.percentage2 = Math.round(this.chart2.data[0] * 100 / this.totalPolls);
    this.percentage3 = Math.round(this.chart3.data[0] * 100 / this.totalPolls);
    this.percentage4 = Math.round(this.chart4.data[0] * 100 / this.totalPolls);
  }

}
